import { FilterBlocksEnum, IFilterGridItem } from '@/interfaces/constructor.interfaces';

import { FilterOperatorsEnum, FilterSeparatorSymbolsEnum } from '../types';

import splitCompositeFilterPath from './splitCompositeFilterPath';

/**
 * Разбить составной ключ поля для фильтра на составляющие
 * @param paths {object} Составные пути
 */
const getCompositeFilterField = (item: IFilterGridItem): Record<string, string> => {
  const { path, field } = splitCompositeFilterPath(item.path);
  switch (item.type) {
    case FilterBlocksEnum.FilterLocation:
    case FilterBlocksEnum.FilterSelect:
    case FilterBlocksEnum.FilterMultipleSelect:
    case FilterBlocksEnum.FilterCheckboxGroup:
    case FilterBlocksEnum.FilterModelCheckboxGroup:
    case FilterBlocksEnum.FilterColorPicker:
    case FilterBlocksEnum.FilterDuoColorPicker: {
      const key = field
        ? `${item.key}${FilterSeparatorSymbolsEnum.Operator}${FilterOperatorsEnum.NestedField}[${
            field.key
          }=${JSON.stringify(field.value)}]`
        : item.key;

      return {
        [`${key}`]: `distinct(${path})`,
      };
    }
    case FilterBlocksEnum.FilterSlider:
    case FilterBlocksEnum.FilterRangeSlider: {
      const { key } = item;

      return {
        [`${key}${FilterSeparatorSymbolsEnum.Operator}${FilterOperatorsEnum.Min}`]: `min(${path})`,
        [`${key}${FilterSeparatorSymbolsEnum.Operator}${FilterOperatorsEnum.Max}`]: `max(${path})`,
      };
    }
    default:
      return {};
  }
};

export default getCompositeFilterField;
